import PostsPageSuperAdmin from './PostsPageSuperAdmin';

export default PostsPageSuperAdmin;
